<template>
  <v-card class="d-flex pa-4 flex-column" outlined>
    <TableSearchFilter
      :search="filterValue"
      @search="updateSearch" 
      @showType="showType"
      :filters="filterType"
    />
    <TableView
      :headers="headers"
      :items="allData"
      :options.sync="options"
      :loading="loading"
      :totalData="totalData"
      :customTopActions="true"
      :expandedItem="true"
      item-key="_id"
    >
      <template v-slot:expanded-item="{ item }">
        <td :colspan="headers.length">
          <div class="row sp-details">
            <!-- Request Header -->
            <div class="col-12 mb-4">
              <strong>Request Header</strong>
              <div class="json-text">
                {{ item.request_header ? JSON.stringify(item.request_header, null, 2) : 'Null' }}
                <v-btn
                  icon
                  small
                  class="clipboard-icon"
                  @click="copyToClipboard(item.request_header)"
                >
                  <v-icon size="18">mdi-clipboard-multiple</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Request Body -->
            <div class="col-12 mb-4">
              <strong>Request Body</strong>
              <div class="json-text">
                {{ item.request_raw ? JSON.stringify(item.request_raw, null, 2) : 'Null' }}
                <v-btn
                  icon
                  small
                  class="clipboard-icon"
                  @click="copyToClipboard(item.request_raw)"
                >
                  <v-icon size="18">mdi-clipboard-multiple</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Response Header -->
            <div class="col-12 mb-4">
              <strong>Response Header</strong>
              <div class="json-text">
                {{ item.response_header ? JSON.stringify(item.response_header, null, 2) : 'Null' }}
                <v-btn
                  icon
                  small
                  class="clipboard-icon"
                  @click="copyToClipboard(item.response_header)"
                >
                  <v-icon size="18">mdi-clipboard-multiple</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Response Body -->
            <div class="col-12 mb-4">
              <strong>Response Body</strong>
              <div class="json-text">
                {{ item.response_raw ? JSON.stringify(item.response_raw, null, 2) : 'Null' }}
                <v-btn
                  icon
                  small
                  class="clipboard-icon"
                  @click="copyToClipboard(item.response_raw)"
                >
                  <v-icon size="18">mdi-clipboard-multiple</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Method -->
            <div class="col-12 col-md-6 mb-4">
              <strong>Method</strong>
              <div class="json-text">
                {{ item.method }}
                <v-btn
                  icon
                  small
                  class="clipboard-icon"
                  @click="copyToClipboard(item.method)"
                >
                  <v-icon size="18">mdi-clipboard-multiple</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Service Path -->
            <div class="col-12 col-md-6 mb-4">
              <strong>Service Path</strong>
              <div class="json-text">
                {{ item.uri }}
                <v-btn
                  icon
                  small
                  class="clipboard-icon"
                  @click="copyToClipboard(item.uri)"
                >
                  <v-icon size="18">mdi-clipboard-multiple</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Server Hostname -->
            <div class="col-12 col-md-6 mb-4">
              <strong>Server Hostname</strong>
              <div class="json-text">
                {{ item.hostname }}
                <v-btn
                  icon
                  small
                  class="clipboard-icon"
                  @click="copyToClipboard(item.hostname)"
                >
                  <v-icon size="18">mdi-clipboard-multiple</v-icon>
                </v-btn>
              </div>
            </div>

            <!-- Error Description -->
            <div class="col-12 col-md-6 mb-4">
              <strong>Error Description</strong>
              <div class="json-text">
                {{ item.error_description || 'Null' }}
                <v-btn
                  icon
                  small
                  class="clipboard-icon"
                  @click="copyToClipboard(item.error_description)"
                >
                  <v-icon size="18">mdi-clipboard-multiple</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </td>
      </template>

      <template v-slot:custom="{ item }">
        {{ item.request_header?.['x-origin-path'] || 'Null' }}
      </template>

      <template v-slot:custom_status="{ item }">
        <v-chip
          :color="item.status === 'success' ? '#4CAF50' : (item.status === 'failed' ? '#F44336' : '#9E9E9E')"
          text-color="white"
          small
        >
          {{ item.status }}
        </v-chip>
      </template>
    </TableView>
    </v-card>
    
  </template>

<script>
import auditTrailAdminMixin from "@components/system-log/audit-trail/portal-admin/auditTrailAdminMixin";


export default {
  mixins: [  auditTrailAdminMixin ],
  components: {
    TableSearchFilter: () => import("@components/@drontVue/components/SearchFilter/TableSearchFilter.vue"),
    TableView: () => import("@components/@drontVue/components/Table/TableView.vue"),
  },

};
</script>

<style scoped>
.button-expand {
  padding: 0 !important; 
}
::v-deep .expand_action {
  padding: 0 !important;
  text-align: center;
}
.grid-layout {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px; 
  padding: 5px;
}

.grid-layout div {
  margin-bottom: 10px; 
}
.json-text {
  position: relative;
  background-color: #eeeeee;
  font-family: 'Courier New', Courier, monospace;
  font-size: 0.8rem;
  font-weight: bold;
  color: #333333;
  padding: 8px;
  padding-right: 45px;
  border-radius: 4px;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  min-height: 30px;
  word-break: break-all;
}
.clipboard-icon {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1;
  background-color: transparent;
  color: #555;
  transition: color 0.3s;
}

.clipboard-icon:hover {
  color: #000;
}
.sp-details {
  padding: 10px;
  margin: 10px 0 0 15px;
}
</style>
